module.exports = __webpack_public_path__ + "static/img/card_cn.82e1bb0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/card_cn.gif
// module id = 25
// module chunks = 0